import React, { Component } from "react"
import { noYes, hard2easy } from '../../variables/ComboValues'
import { RadioSelect } from '../../elements/RadioSelect/RadioSelect'
import { updateElement, empty_family_products_services } from "../Tree/Utils.js"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'

export const  ProductsServices_microLegend = {
    //"q1": "בחצי שנה האחרונה האם קרה שוויתרת על אחד או יותר מהשירותים הרפואיים הבאים בשבילך או בשביל המשפחה שלך, בגלל העלות שלהם?",
    "q101": "רכישת תרופות",
    "q102": "טיפולי שיניים",
    "q103": "עזרים רפואיים (מכשירי שמיעה, משקפיים, אוכל מיוחד, ויטמינים וכדומה)",
    "q104": "ביקור אצל רופא",
    "q105": "בדיקות",
    "q106": "טיפולים רפואיים",
    "q107": "טיפולים פארה-רפואיים",
    "q108": "טיפולים התפתחותיים / רגשיים",
    "q109": "ויתרנו על שירות אחר, כלשהו בגלל העלות הכספית שלו",
    "q110": "אם כן, מהו?",
    "q201": "מקרר",
    "q202": "כיריים לבישול",
    "q203": "תנור אפיה",
    "q204": "מכונת כביסה",
    "q205": "תנור / אמצעי לחימום",
    "q206": "דוד חימום / דוד שמש",
    "q207": "מיטה לכל אחד מבני המשפחה",
    "q208": "ארונות",
    "q209": "שמיכות חורף",
    "q210": "פרטי מטבח מרכזיים לבישול/אפיה/אכילה",
    "q211": "ביגוד והנעלה",
    "q212": "ספרי קריאה וצעצועים לילדים",
    "q213": "ציוד לבי''ס לכל ילד",
    "q214": "מוצרי יסוד כגון: בשר/עוף, ירקות, פירות, מוצרי חלב",
    "q215": "יש את כל הדברים שצויינו ברשימה",
    "q31": "מחשב",
    "q32": "חיבור פעיל לאינטרנט",
    "q33": "מכונית",
    "q401": "מקומות העבודה",
    "q402": "מעונות / משפחתונים / מטפלת",
    "q403": "גני ילדים",
    "q404": "בתי ספר",
    "q405": "שוק / סופרמרקט",
    "q406": "קופת חולים",
    "q407": "בית מרקחת",
    "q408": "שירותי בריאות אחרים",
    "q409": "מועדון / מרכז חוגים /מתנ''ס / מינהל קהילתי",
    "q410": "בני משפחה קרובים",
    "q411": "חברים",
    "q412": "מרכזי קניות, בילוי ושירות",
    "q413": "אחר",
    "comments": "הערות"
}

export class FamilyProductsServices extends Component {

    constructor(props) {
      super(props)
      //this.state = { products: this.props.data }
      const {data} = this.props
      this.state = {products: (data === undefined || data === false)? {...empty_family_products_services} : data}
      //this.onSaveTable = this.onSaveTable.bind(this)
      //this.handleProductTable = this.handleProductTable.bind(this)
    }

    handleProductTable = (evt) => {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable = (evt) => {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      //console.log("Family general this.state.products=", this.state.products)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
         
            headerColumns = {[ "total_expenses", "total_education", "total_shotef", "total_debts_return",
            "total_family_expenses", "total_family_balance", "balance_comment" ]}
            tableTitle = {tableTitle} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
          filterText : "",
          detailedDisplay: false
      }
      this.toggleDisplay = this.toggleDisplay.bind(this)
  }
  toggleDisplay(evt){
    let tog = !this.state.detailedDisplay
    this.setState({detailedDisplay: tog})
    // console.log("toggleDisplay - now= ", tog ?"true":"false")
  }
    
  handleUserInput(filterText) {
      this.setState({filterText: filterText});
  }
  render() {
    const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
    var buttonStyle = {marginRight: '0'}
    // console.log("General - products", products)
    
    var product = []
    var cellData = []
    //if (typeof products === "undefined" || products=== false)
    //  product = empty_family_products_services
    //else
    product = products
    cellData=[{
          newsection: "בחצי שנה האחרונה האם קרה שוויתרת על אחד או יותר מהשירותים הרפואיים הבאים בשבילך או  בשביל המשפחה שלך, בגלל העלות שלהם?",
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q101",
          value: product.q101,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q102",
          value: product.q102,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q103",
          value: product.q103,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q104",
          value: product.q104,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q105",
          value: product.q105,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q106",
          value: product.q106,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q107",
          value: product.q107,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q108",
          value: product.q108,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q109",
          value: product.q109,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "text",
          name: "q110",
          value: product.q110,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          newsection: "האם בבית שלכם חסר אחד או יותר מהציוד או המוצרים הבאים?",
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q201",
          value: product.q201,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q202",
          value: product.q202,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q203",
          value: product.q203,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q204",
          value: product.q204,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q205",
          value: product.q205,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q206",
          value: product.q206,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q207",
          value: product.q207,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q208",
          value: product.q208,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q209",
          value: product.q209,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q210",
          value: product.q210,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q211",
          value: product.q211,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q212",
          value: product.q212,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q213",
          value: product.q213,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q214",
          value: product.q214,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q215",
          value: product.q215,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          newsection: "האם יש ברשותכם הדברים הבאים",
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q31",
          value: product.q31,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q32",
          value: product.q32,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: noYes,  // ["לא", "כן"],
          name: "q33",
          value: product.q33,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          newsection: "באמצעים שעומדים לרשותכם, באיזו מידה ניתן להגיע בקלות ממקום מגוריך לשירותים ולאנשים הבאים?",
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q401",
          value: product.q401,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q402",
          value: product.q402,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q403",
          value: product.q403,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q404",
          value: product.q404,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q405",
          value: product.q405,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q406",
          value: product.q406,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q407",
          value: product.q407,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q408",
          value: product.q408,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q409",
          value: product.q409,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q410",
          value: product.q410,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, // ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q411",
          value: product.q411,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, //  ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q412",
          value: product.q412,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "radioSelect",
          options: hard2easy, //  ["קשה מאוד","קשה","די קל","קל","קל מאוד"],
          name: "q413",
          value: product.q413,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
          type: "textarea",
          name: "comments",
          value: product.comments,
          id: product.id,
          style: {width: "300px"},
          edit: true
        }]  

       
      return (
        <div className="yahav-modal">
            <h2 className="sub-tab-title">{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left  update-button" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform evenodd width1140">
                <button style={buttonStyle} type="button"  className="btn btn-success pull-left" 
                        onClick={this.toggleDisplay}>שינוי תצוגה</button>
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    product={product} 
                    cd={cellData}
                    detailedDisplay = {this.state.detailedDisplay}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends Component {
    
    render() {
      const {onProductTableUpdate, cd, detailedDisplay} = this.props
      var key = 0;
      if (cd === "undefined" || !cd.length)
        return (<h4>קבוצת השדות לא מוגדרות במאגר המידע<br/>כנראה בעיה במעבר מאינטייק למשפחה</h4>)
    //console.log("ProductRow = cd=", cd)
      return (
        <div className="eachRow" >
        {cd.map(cellInfo => {
            if (typeof cellInfo.newsection !== "undefined")
              return(
              <React.Fragment key={key++}>
                <h3 key={key++} >{cellInfo.newsection}</h3>
                <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} 
                                      cellData={cellInfo} detailedDisplay={detailedDisplay} />

              </React.Fragment>
              )
            return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} 
                                      cellData={cellInfo} detailedDisplay={detailedDisplay} /> )
        })}
        </div>
      )
  
    }
  
  }
  
  class EditableFormCell extends React.PureComponent {
    render() {
        const tp = this.props
        const tpc = tp.cellData
        const detailedDisplay = tp.detailedDisplay

        //const divStyle= {padding: 0, verticalAlign: 'top', borderTop: 0, display: 'block', margin: '0 3px 0 8px' }
        const divStyleBblock = {padding: 0, verticalAlign: 'top', borderTop: 0, display: 'block', margin: '0 3px 5px 8px' }
        const labelStyle = {width: '30%', verticalAlign: 'top'}

        if (tpc.type === "radioSelect" || tpc.type === "select"){
          if (detailedDisplay)
            tpc.type = "radioSelect"
          else
            tpc.type = "select"
        }

        if (tpc.type === "radioSelect")
          return (
            <div className="form-line" style={divStyleBblock}>
            <span style={{width:'2%', display:'inline-block',verticalAlign:'top',textAlign:'left',marginLeft:'1%'}}>{tpc.name+"."}</span>
              <label style={labelStyle} htmlFor={tpc.id}>{ProductsServices_microLegend[tpc.name]}</label>
              <RadioSelect value={tpc.value} options={tpc.options} onChange={tp.onProductTableUpdate} id={tpc.id} name={tpc.name} />
            </div>
          )
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box">
            <span style={{width:'2%', display:'inline-block',verticalAlign:'top',textAlign:'left',marginLeft:'1%'}}>{tpc.name+"."}</span>
            <label style={{ width: '50%'}} htmlFor={tpc.id}>{ProductsServices_microLegend[tpc.name]}</label>
            <SelectF tp={tp} tpc={tpc} overstyle={{display: 'inline-block', verticalAlign : 'top'}} />
              {/*<select style={{display: 'inline-block', verticalAlign : 'top'}} name={tpc.name} id={tpc.id} value={tpc.value} onChange={tp.onProductTableUpdate} > 
                <option key={1111111} value="נא לבחור" > נא לבחור </option>
                {tpc.options.map(item => {
                    return(<option key={item} value={item}>{item}</option>)
                    })
                }
              </select>*/}
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box">
            {/*<span style={{width:'2%', display:'inline-block',verticalAlign:'top',textAlign:'left',marginLeft:'1%'}}>{tpc.name+"."}</span>*/}

              <label style={{ width: '53%', verticalAlign:'top'}} htmlFor={tpc.id}>{ProductsServices_microLegend[tpc.name]}</label>
              <TextareaF tp={tp} tpc={tpc} />

            </div>
          )
        }
        return (
          <div className="form-cell-box">
            <span style={{width:'2%', display:'inline-block',verticalAlign:'top',textAlign:'left',marginLeft:'1%'}}>{tpc.name+"."}</span>

            <label style={{ width: '50%'}} htmlFor={tpc.id}>{ProductsServices_microLegend[tpc.name]}</label>

            <InputF tp={tp} tpc={tpc} />

          </div>
        )
  
    }
  }
